










import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import ParticipantTable from "@share/participants-table/components/ParticipantTable.vue";
import ParticipantsTable from "@share/participants-table/ParticipantsTable.vue";
import {ParticipantsDataHelper} from "@mixins/ParticipantsDataHelper";
import IsParticipantsLimited from "@mixins/isParticipantsLimited";
import {
    AnalyticsVisitor,
} from "@api/repositories/interfaces/PartnerAnalyticsDataInterface";
import {ColumnFieldInterface} from "@share/participants-table/models/ColumnFieldInterface";
import {getFields} from "@share/participants-table/helpers/FieldsHelper";
import {ParticipantsFiltersAvailability} from "@share/participants-table/types/ParticipantsFiltersAvailability";
import {filtersAvailabilityDefaultValue} from "@share/participants-table/helpers/FiltersHelper";
import {CustomParticipantData, CustomParticipantsData} from "@share/participants-table/types/CustomParticipantsData";
import {AnalyticsHelper} from "@share/catalog/helpers/AnalyticsHelper";

@Component({
  name: "AnalyticsUsers",
  components: {ParticipantsTable, ParticipantTable}
})
export default class AnalyticsUsers extends Mixins(IsParticipantsLimited) {
  @Prop({required: true}) analyticsDataHelper: AnalyticsHelper | undefined;
  static readonly VISITS_FIELD_NAME = 'visits';
  static readonly DURATION_FIELD_NAME = 'duration';

  dataHelper: ParticipantsDataHelper | null = null;
  fields: ColumnFieldInterface[] = [];
  filtersAvailability: ParticipantsFiltersAvailability | null = null;
  isInitialized = false;
  customFields: ColumnFieldInterface[] = [
      {
          label: '',
          fieldName: AnalyticsUsers.VISITS_FIELD_NAME
      },
      {
          label: '',
          fieldName: AnalyticsUsers.DURATION_FIELD_NAME
      },
  ];

  mounted() {
    this.filtersAvailability = filtersAvailabilityDefaultValue(["online"]);

    this.fields = [...getFields(this.$store, ["lastName", "company"]), ...this.customFields];

    const userIds = this.analyticsDataHelper?.analyticsData?.exhibition?.visitors
        ? Object.values(this.analyticsDataHelper?.analyticsData?.exhibition?.visitors).map((item: AnalyticsVisitor) => item.userId as number)
        : [];

    this.dataHelper = new ParticipantsDataHelper(
        this.$repositories,
        this.$store.state.events.selected,
        this.$store.state.session.userId,
        this.participantsGroupIds(),
        this.$store,
        userIds,
        this.prepareCustomData(),
        true
    );
    this.dataHelper.take = userIds.length;
    this.dataHelper.filterOrder = AnalyticsUsers.DURATION_FIELD_NAME;
    this.dataHelper.filterDirection = 'desc';
    // this.dataHelper.additionalFields = prepareAdditionalFields(this.fields);
    const firstColumnLabel = this.$t('participants.firstColumnLabel') as string;
    this.fields.splice(0, 0, { label: firstColumnLabel, fieldName: "lastName" });
    this.isInitialized = true;
  }

  prepareCustomData(): CustomParticipantsData {
      let result: CustomParticipantsData = {};
      if (this.analyticsDataHelper?.analyticsData?.exhibition?.visitors) {
          Object.values(this.analyticsDataHelper?.analyticsData?.exhibition?.visitors).map((analyticsVisitor: AnalyticsVisitor) => {
              let participantCustomData: CustomParticipantData = {};

              this.customFields.forEach(customField => {
                  participantCustomData[customField.fieldName] = customField.fieldName == AnalyticsUsers.DURATION_FIELD_NAME
                      ? Math.ceil(analyticsVisitor[customField.fieldName] / 60)
                      : analyticsVisitor[customField.fieldName];
              });

              result[analyticsVisitor.userId] = participantCustomData;
          })
      }
      return result;
  }

}
